import { DeleteIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { deleteEndOfJourneyTemplates } from '../../../api/end-of-journey-templates/delete-end-of-journey-templates'
import { EndOfJourneyTemplate } from '../../../lib/types/models/end-of-journey-template/end-of-journey-template'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

interface EndOfJourneyTemplateDeleteModalProps {
  template: EndOfJourneyTemplate
  open: boolean
  onClose: () => void
  onSuccess?: () => void
}

const EndOfJourneyTemplateDeleteModal = ({
  template,
  open,
  onClose,
  onSuccess
}: EndOfJourneyTemplateDeleteModalProps) => {
  const { mutateAsync: deleteTemplate, isPending } = useMutation({
    mutationFn: deleteEndOfJourneyTemplates,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Modèle de fin de séjour supprimé avec succès')
      onClose()
      onSuccess?.()
    }
  })

  return (
    <Modal
      isOpen={open}
      onCancel={onClose}
      title={`Êtes-vous sûr de vouloir supprimer le modèle de fin de séjour "${template.name}" ?`}
      actionButtonsOptions={{
        confirmText: 'Supprimer',
        cancelText: 'Fermer',
        onConfirm: async () => deleteTemplate({ ids: [template.id] })
      }}
      icon={DeleteIcon}
      variant={'destructive'}
      isLoading={isPending}
    />
  )
}

export default EndOfJourneyTemplateDeleteModal
